import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { motion, useIsPresent } from 'framer-motion';
import { useCallback } from 'react';
const TRANSITION_VH = 40;
const TRANSITION_SEC = 0.2;
const variants = {
    in: {
        y: '0',
        opacity: 1,
        transition: {
            duration: TRANSITION_SEC,
            ease: 'easeOut',
        },
    },
    out: {
        y: `-${TRANSITION_VH}vh`,
        opacity: 0,
        transition: {
            duration: TRANSITION_SEC,
            ease: 'easeOut',
        },
    },
};
const CardWrapper = ({ wide, onEnter, children }) => {
    const isPresent = useIsPresent();
    const handleEnter = useCallback(() => {
        if (isPresent)
            onEnter?.();
    }, [isPresent, onEnter]);
    const classes = classNames('w-full relative mx-auto', wide
        ? 'tablet-portrait:w-full tablet-landscape:w-[75%]'
        : 'tablet-portrait:w-[65%] tablet-landscape:w-[50%]', 'laptop:w-96');
    return (_jsx(motion.div, { className: classes, variants: variants, initial: "out", animate: "in", exit: "out", onAnimationStart: handleEnter, children: children }));
};
export default CardWrapper;
